module.exports = __webpack_public_path__ + "img/edit.8626c4e9.svg";